<script setup>
import { provide, ref } from "vue";
import Toast from "@/Components/Toast.vue";

const toast = ref({
    message: "",
    type: "info",
    visible: false,
    keepOpen: false,
});

const showToast = (message, type = "info", keepOpen = false, duration = 3000) => {
    toast.value = { message, type, visible: true, keepOpen };

    if (!keepOpen) {
        setTimeout(() => (toast.value.visible = false), duration);
    }
};

provide("showToast", showToast);
</script>

<template>
    <slot />
    <Toast
        v-if="toast.visible"
        :message="toast.message"
        :type="toast.type"
        @close="toast.visible = false"
    />
</template>
